module.exports = __webpack_public_path__ + "static/img/card_mercado.8e433346.png";